'use client';

import styles from './events-and-tours-app.module.scss';
import EventCard from 'components/cards/event-card';
import { formatDate } from 'helpers/date-time';
import { NYC_IANA_TIMEZONE } from 'lib/constants.mjs';
import NoResults from 'components/search/no-results';
import Subsection from 'components/containers/sub-section';
import { useLocale } from 'next-intl';

const EventsDisplay = ({ results }: Props) => {
	const locale = useLocale();
	// Group results by day into an object using the date as the key
	const groupedResults = results
		.map((item) => item._source)
		.reduce((groupedResult, item) => {
			const key = item.startDate.substring(0, 11);
			groupedResult[key] = groupedResult[key]?.length
				? [...groupedResult[key], item]
				: [item];
			return groupedResult;
		}, {});

	return (
		<>
			{Object.keys(groupedResults)?.length > 0 ? (
				<div className={styles.groupContainer}>
					{Object.keys(groupedResults).map((key) => {
						return (
							<div className={styles.dateContainer} key={key}>
								<h3 className={styles.date}>
									{formatDate(
										key,
										{
											weekday: 'long',
											month: 'long',
											day: 'numeric',
											timeZone: NYC_IANA_TIMEZONE,
										},
										locale,
									)}
								</h3>
								<div>
									{groupedResults[key].map((item) => {
										const { aceId, title } = item; // aceIds are actually not unique it turns out: https://met-museum.slack.com/archives/G01KTHKKNMP/p1738810943827419
										return (
											<div
												key={`${aceId}-${title}-wrapper`}
												className={styles.eventWrapper}
											>
												<EventCard
													key={`${aceId}-${title}`}
													isEvent={true}
													{...item}
												/>
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
			) : (
				<Subsection>
					<NoResults
						title={`No Results Found`}
						body="Try broadening your search."
					/>
				</Subsection>
			)}
		</>
	);
};

type Props = {
	results: any[];
};

export default EventsDisplay;
